import { render, staticRenderFns } from "./liveCommentSettings.vue?vue&type=template&id=ede06d5c&"
import script from "./liveCommentSettings.vue?vue&type=script&lang=js&"
export * from "./liveCommentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports